import L from 'leaflet';
import * as turf from '@turf/turf';
import { zIndexLayer } from './zIndexLayerDefine';

export const drawLoteOutline = (layer, map, statusFilter) => {
    const loteSelecionado = parseInt(statusFilter.split(' ')[1]);
    const loteLayers = [];

    layer.eachLayer(l => {
        if (parseInt(l.feature?.properties?.lote) === loteSelecionado) {
            loteLayers.push(l.feature);
        }
    });

    if (loteLayers.length > 0) {
        const multi = turf.combine({
            type: "FeatureCollection",
            features: loteLayers
        });
        const polygons = multi.features[0].geometry.coordinates.map(coords => {
            return turf.polygon(coords);
        });

        let unioned = polygons[0];
        let zIndex = zIndexLayer("");

        for (let i = 1; i < polygons.length; i++) {
            unioned = turf.union(turf.featureCollection([unioned, polygons[i]]));
        }

        if (!map.getPane('outline-pane')) {
            map.createPane('outline-pane');
        }
        map.getPane('outline-pane').style.zIndex = zIndex;
        
        if (unioned) {
            const border = L.geoJSON(unioned, {
                pane: 'outline-pane',
                interactive: false,
                style: {
                    color: 'black',
                    weight: 3,
                    fillOpacity: 0
                }
            }).addTo(map);
            border._lote = loteSelecionado;
            layer._outline = border;
        }
    }
};
